@let favorites = favoritesStationsSignal();
@if (favorites?.length > 0) {
  <div class="container-grid">
    @for (favorite of favorites; track favorite.id) {
      <button class="grid-element" (click)="onClickFavorite(favorite)">


        @if ((getIconContent(favorite) | async); as icon) {
          <img [src]="dynamicContentUrlSignal() + icon" [alt]="">
        }
        <h2>{{favorite.title[translate.getCurrentLang()]}}</h2>

        <button (click)="onClickDeleteFavorite($event, favorite.id)">{{'delete' | translate}}</button>
      </button>
    }
  </div>

} @else {
  <div class="container-empty">
    <p class="text-center">{{'tipps_text_1' | translate}}</p>
    <h2 class="text-center">{{'tipps_title_1' | translate}}</h2>
    <ol>
      <li>{{'tipps_text_2' | translate}}</li>
      <li>{{'tipps_text_4' | translate}}</li>
    </ol>
    <p class="text-center">{{'tipps_text_5' | translate}}
      <mat-icon svgIcon="Icons_BOOKMARK_ADD"></mat-icon>
    </p>

  </div>
}